/**
 * React hook — lazy-loads FX rates once per session.
 * Components that need the rates (versus-page, app-detail pricing tier)
 * call `const rates = useFxRates()` and pass the result to
 * `planApproximations(plan, rates, lang)`.
 */
import { useEffect, useState } from "react";
import { fetchRates, peekRates } from "@/lib/fx";

export const useFxRates = () => {
  const [rates, setRates] = useState(() => peekRates());
  useEffect(() => {
    let cancelled = false;
    if (!rates) {
      fetchRates().then((r) => {
        if (!cancelled) setRates(r);
      });
    }
    return () => { cancelled = true; };
  }, [rates]);
  return rates;
};
